module.exports = __webpack_public_path__ + "static/media/5.bb6d9bf9.jpg";